function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import $ from 'jquery';
import { Consts, window, resizeMediaUrl, resizeMediaUrlWithWatermark, experiments } from '@wix/photography-client-lib';
import { GalleryItem } from 'pro-gallery-lib';
import Swipper from './swipper.js';
import { utils, prepareFullscreenItem, replaceWindowElement, createFullscreenStyle } from '../utils';
import { isSEOMode, viewModeWrapper } from '../utils/viewModeWrapper.js';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import MobileExpand from './MobileExpand';
import MobileFullscreen from './MobileFullscreen';
import DesktopExpand from './DesktopExpand';
import DesktopFullscreen from './DesktopFullscreen';
import MobileZoom from './MobileZoom';
utils.fixViewport('Fullscreen');

function defaultNavigateAction(url) {
  window.open(url);
}

var ProFullscreen = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ProFullscreen, _React$Component);

  function ProFullscreen(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", _.throttle(function () {
      $('.fullscreen-icon').show().css('opacity', '1');
      $('body').removeClass('no-cursor');
      clearTimeout(_this.mouseMovedTimeout);

      if (_this.state.isFullscreen && utils.isMobile()) {
        if (!_this.getItem().isDemo && !utils.isTouch()) {
          _this.mouseMovedTimeout = setTimeout(function () {
            $('body').addClass('no-cursor');
            $('.fullscreen-icon').css('opacity', '0');
          }, 3000);
        }
      }
    }, 100).bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "handleKeypress", _.throttle(function (e) {
      var isRTL = _this.props.styles.isRTL;

      switch (e.keyCode || e.charCode) {
        case 38: //up

        case 37: //left

        case 33:
          //page up
          e.preventDefault();

          _this.nextSlide(isRTL ? 1 : -1);

          return false;

        case 39: //right

        case 40: //down

        case 34:
          //page down
          e.preventDefault();

          _this.nextSlide(isRTL ? -1 : 1);

          return false;

        case 27:
          //esc
          e.preventDefault();

          _this.handleMouseMove();

          _this.closeBrowserFullscreen();

          return false;

        case 9:
          //tab
          var activeElementClasses = document.activeElement.classList;

          if (e.shiftKey) {
            if (activeElementClasses.contains('pro-fullscreen-arrow') && ( //one of the arrows
            activeElementClasses.contains('arrow-left') || //left arrow
            activeElementClasses.contains('arrow-right') && //or right arrow when left arrow is disabled
            _this.state.current.idx <= 0)) {
              // the left arrow or (the right arrow when left arrow is disabled) is the last icon in the shift-tab-order.
              // if another shift-tab was pressed, we want to focus again on the close icon
              e.preventDefault();

              _this.setState({
                shouldRefocusOnCloseXButton: true
              }, function () {
                _this.setState({
                  shouldRefocusOnCloseXButton: false
                });
              });

              return false;
            }
          } else {
            if (activeElementClasses.contains('pro-fullscreen-x-button')) {
              // close icon is the last icon in fullscreen tab-order.
              // if another tab was pressed, we want to focus again on one of the arrows (the correct one).
              e.preventDefault();

              _this.setState({
                refocusArrows: true
              }, function () {
                _this.setState({
                  refocusArrows: false
                });
              });

              return false;
            }
          }

          break;

        default:
      }

      _this.handleMouseMove();

      return true; //continue handling the original keyboard event
    }, 100).bind(_assertThisInitialized(_this)));

    _defineProperty(_assertThisInitialized(_this), "onFullscreenChange", function () {
      // exit fullscreen
      if (!window.document.fullscreenElement && !window.document.webkitIsFullScreen && !window.document.mozFullScreen && !window.document.msFullscreenElement) {
        if (_this.state.isFullscreen) {
          _this.setState({
            isFullscreen: false,
            showInfo: _this.props.styles.defaultShowInfoExpand && _this.state.current.hasInfo,
            infoToggledByUser: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onOrientationChange", function () {
      _this.isLandscape = _this.isLandscapeInMobile();

      if (!_this.itemClickIsOpenInFullscreen && !_this.state.isFullscreen) {
        _this.setState({
          isFullscreen: _this.isLandscape
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setIsSwipping", _.debounce(function (bool) {
      return _this.isSwipping = bool;
    }, 300).bind(_assertThisInitialized(_this)));

    _this.eventsListener = _this.eventsListener.bind(_assertThisInitialized(_this));
    _this.fadeToNextSlide = _this.fadeToNextSlide.bind(_assertThisInitialized(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind(_assertThisInitialized(_this));
    _this.getItemsToDisplay = _this.getItemsToDisplay.bind(_assertThisInitialized(_this));
    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
    _this.toggleShareScreen = _this.toggleShareScreen.bind(_assertThisInitialized(_this));
    _this.toggleInfo = _this.toggleInfo.bind(_assertThisInitialized(_this));
    _this.openBrowserFullscreen = _this.openBrowserFullscreen.bind(_assertThisInitialized(_this));
    _this.closeBrowserFullscreen = _this.closeBrowserFullscreen.bind(_assertThisInitialized(_this));
    _this.handleOnTap = _this.handleOnTap.bind(_assertThisInitialized(_this));
    _this.onTouchStart = _this.onTouchStart.bind(_assertThisInitialized(_this));
    _this.onTouchMove = _this.onTouchMove.bind(_assertThisInitialized(_this));
    _this.onTouchEnd = _this.onTouchEnd.bind(_assertThisInitialized(_this));
    _this.toggleZoom = _this.toggleZoom.bind(_assertThisInitialized(_this));
    _this.setRef = _this.setRef.bind(_assertThisInitialized(_this));
    _this.setCurrentItem = _this.setCurrentItem.bind(_assertThisInitialized(_this));

    if (typeof props.formFactor !== 'undefined') {
      viewModeWrapper.setFormFactor(props.formFactor);
    }

    if (typeof props.viewMode !== 'undefined') {
      viewModeWrapper.setViewMode(props.viewMode);
    }

    _this.extraImages = utils.isMobile() ? 2 : 5; //number of images to preload on each side of the fullscreen

    _this.actions = {
      toggleInfo: _this.toggleInfo,
      toggleShareScreen: _this.toggleShareScreen,
      next: _this.nextSlide,
      openBrowserFullscreen: _this.openBrowserFullscreen,
      closeBrowserFullscreen: _this.closeBrowserFullscreen,
      eventsListener: _this.eventsListener,
      toggleFullscreen: _this.toggleFullscreen,
      fadeToNextSlide: _this.fadeToNextSlide,
      toggleZoom: _this.toggleZoom,
      setCurrentItem: _this.setCurrentItem
    }; //TODO: replace with css modules

    replaceWindowElement({
      type: 'style',
      id: 'inlineDynamicFullscreenWixParamsCss',
      attributes: {
        type: 'text/css'
      },
      innerHTML: createFullscreenStyle(props.styles),
      parentElement: window.document.getElementsByTagName('head')[0]
    });

    if (props.styles.googleFontsCssUrl) {
      replaceWindowElement({
        type: 'style',
        id: 'inlineDynamicFullscreenWixParamsFont',
        attributes: {
          type: 'text/css',
          rel: 'stylesheet',
          href: props.styles.googleFontsCssUrl
        },
        parentElement: window.document.getElementsByTagName('head')[0]
      });
    }

    _this.itemClickIsOpenInFullscreen = props.styles.itemClick === 'fullscreen';
    _this.state = {
      isFullscreen: _this.itemClickIsOpenInFullscreen,
      animating: false,
      showShareScreen: false,
      showShare: false,
      refocusArrows: false,
      initialArrowsFocus: false,
      shouldRefocusOnCloseXButton: false,
      isMobileZoom: false
    };
    _this.state.currentWindow = _this.getCurrentWindowState();
    _this.state.current = _this.getItemStateByIdx(props.initialIdx);
    var eventData = {
      item: _this.state.current.item
    };

    _this.eventsListener(FULLSCREEN_EVENTS.UPDATE_CURRENT_ITEM, eventData);

    _this.state.showInfo = props.styles && !_this.itemClickIsOpenInFullscreen && props.styles.defaultShowInfoExpand && _this.state.current.hasInfo;
    _this.isLandscape = _this.isLandscapeInMobile();
    _this.shouldUseProGallerySlider = experiments('specs.pro-gallery.fullscreenAsProGalleryLayout') === 'true';
    return _this;
  }

  var _proto = ProFullscreen.prototype;

  _proto.eventsListener = function eventsListener(eventName, eventData) {
    if (typeof this.props.eventsListener === 'function') {
      this.props.eventsListener(eventName, eventData);
    }
  };

  _proto.isLandscapeInMobile = function isLandscapeInMobile() {
    return utils.isMobile() && (window.orientation === 90 || window.orientation === -90);
  };

  _proto.initEvents = function initEvents() {
    window.addEventListener('keydown', this.handleKeypress);
    window.addEventListener('fullscreenchange', this.onFullscreenChange);
    window.addEventListener('webkitfullscreenchange', this.onFullscreenChange);
    window.addEventListener('mozfullscreenchange', this.onFullscreenChange);
    window.addEventListener('MSFullscreenChange', this.onFullscreenChange);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mousedown', this.handleMouseMove);
    window.addEventListener('orientationchange', this.onOrientationChange);

    if (utils.isMobile() && this.shouldUseProGallerySlider) {
      window.addEventListener('touchstart', this.onTouchStart);
      window.addEventListener('touchmove', this.onTouchMove);
      window.addEventListener('touchend', this.onTouchEnd);
    }
  };

  _proto.clearEvents = function clearEvents() {
    window.removeEventListener('keydown', this.handleKeypress);
    window.removeEventListener('fullscreenchange', this.onFullscreenChange);
    window.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('mozfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('MSFullscreenChange', this.onFullscreenChange);
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mousedown', this.handleMouseMove);
    window.removeEventListener('orientationchange', this.onOrientationChange);

    if (utils.isMobile() && this.shouldUseProGallerySlider) {
      window.removeEventListener('touchstart', this.onTouchStart);
      window.removeEventListener('touchmove', this.onTouchMove);
      window.removeEventListener('touchend', this.onTouchEnd);
    }
  } // TODO remove state from args
  ;

  _proto.getItemStateByIdx = function getItemStateByIdx(idx) {
    if (_.isUndefined(idx)) {
      idx = this.state.current.idx || 0;
    }

    var item = this.getItem(idx);
    return {
      idx: idx,
      item: item,
      hasInfo: this.hasInfo(idx),
      pos: this.getItemsDisplayRange(),
      itemLoveData: this.props.itemsLoveData[item.id]
    };
  };

  _proto.shouldShowInfo = function shouldShowInfo() {
    var _this$state, _this$state$current;

    /* Note: It seems that there are 2 props that are responsible for showing fullscreen-sidebar: 'showInfo' and 'shouldShowInfo' - probably historic reasons..
      See more in 'fullscreenSidebar' component -> isVisible() function
      TODO: need to refactor - merge 'showInfo' and 'shouldShowInfo' ?
    */
    if (!this.state && this.itemClickIsOpenInFullscreen) {
      return false;
    } else if (this.state && this.state.isFullscreen) {
      return false;
    } else if (this.hasAdditionalSidebarElement() && !utils.isMobile()) {
      return true;
    } else if ((_this$state = this.state) != null && (_this$state$current = _this$state.current) != null && _this$state$current.hasInfo && !utils.isMobile() && this.props.styles.defaultShowInfoExpand) {
      return true;
    } else if (this.state) {
      return this.state.showInfo;
    } else {
      return this.props.styles.defaultShowInfoExpand && !utils.isSmallScreen();
    }
  };

  _proto.currentWindowSize = function currentWindowSize() {
    var isMobile = utils.isMobile();
    var dim = {
      width: Math.round(this.props.container.width / utils.getViewportScaleRatio()),
      height: Math.round(this.props.container.height / utils.getViewportScaleRatio())
    };
    var mobilePadding = isMobile ? Consts.dimensions.MOBILE_PADDING : Consts.dimensions.NO_PADDING;

    if (this.shouldShowInfo()) {
      // Without Side Bar width which is 30 percent of the window
      return this.props.styles.expandInfoPosition === Consts.expandInfoPositions.BOTTOM && !isMobile ? {
        width: dim.width,
        height: this.state.current.item.description && this.props.styles.allowDescriptionExpand || !_.isUndefined(this.state.current.item.link.data) ? dim.height * 80 / 100 : dim.height
      } : {
        width: dim.width * 70 / 100,
        height: dim.height - mobilePadding
      };
    } else if (mobilePadding !== 0 && !this.isLandscape) {
      return {
        width: dim.width,
        height: dim.height - mobilePadding
      };
    } else {
      return dim;
    }
  };

  _proto.getCurrentWindowScale = function getCurrentWindowScale() {
    var _this2 = this;

    var scale = {};

    if (this.state.isFullscreen || utils.isSmallScreen()) {
      scale = {
        horizontal: 1,
        vertical: 1
      };
    } else {
      var w = this.currentWindowSize();
      scale = {
        horizontal: (w.width - 100 * 2) / w.width,
        vertical: (w.height - 100 * 2) / w.height
      };
    }

    scale.min = function (item) {
      if (_this2.state.isFullscreen || utils.isSmallScreen()) {
        return 1;
      } else {
        var _w = _this2.currentWindowSize();

        var horizontal = (_w.width - 100 * 2) / item.width;
        var vertical = (_w.height - 100 * 2) / item.height;
        return Math.min(horizontal, vertical);
      }
    };

    return scale;
  };

  _proto.getCurrentWindowState = function getCurrentWindowState() {
    return {
      size: this.currentWindowSize(),
      expanded: this.state.isFullscreen,
      scale: this.getCurrentWindowScale()
    };
  };

  _proto.hasInfo = function hasInfo(idx) {
    var curItem;

    if (!_.isUndefined(idx)) {
      curItem = this.getItem(idx);
    } else if (_.isUndefined(this.state.current)) {
      return false;
    } else {
      curItem = this.getItem(_.get(this, 'state.current.idx') || 0);
    }

    var title = utils.getTitleOrFilename(curItem.title, curItem.fileName) && this.props.styles.allowTitleExpand;
    var description = curItem.description && this.props.styles.allowDescriptionExpand;
    var link = !_.isUndefined(curItem.link.data);
    var hasInfo = title || description || link;
    return hasInfo;
  };

  _proto.setCurrentItem = function setCurrentItem(item) {
    this.setState({
      currentGalleryItem: item
    });
    this.nextSlide(null, item.idx);
  };

  _proto.getItem = function getItem(idx) {
    var _this3 = this;

    var emptyItem = function emptyItem() {
      return new GalleryItem({
        dto: {
          itemId: 'empty-item',
          mediaUrl: '',
          metaData: {
            height: 3744,
            width: 3744
          }
        },
        resizeMediaUrl: resizeMediaUrlWithWatermark(_this3.props.watermark)
      });
    };

    if (!this.state) {
      return emptyItem();
    } else if (!_.isUndefined(idx) && _.isArray(this.props.items)) {
      return this.getOrCreateGalleryItem(idx) || emptyItem();
    } else if (_.get(this, 'state.current.item.id')) {
      return this.state.current.item;
    } else if (_.get(this, 'state.current.idx')) {
      return this.getOrCreateGalleryItem(_.get(this, 'state.current.idx'));
    } else if (_.get(this, 'prerenderedItem.id')) {
      return this.prerenderedItem;
    } else {
      return emptyItem();
    }
  };

  _proto.getNextitem = function getNextitem(idx, direction) {
    var loop = this.props.styles.fullscreenLoop;
    var numOfitems = this.props.items.length;
    var next = idx + direction;

    if (next < 0) {
      return idx;
    } else if (next === numOfitems) {
      return loop ? 0 : idx;
    } else {
      return next;
    }
  };

  _proto.getItemsDisplayRange = function getItemsDisplayRange() {
    var range = utils.isTouch() ? 2 : 5;

    if (!this.state) {
      return range;
    }

    var numOfitems = this.props.items.length - 1;

    if (numOfitems > 0 & this.props.styles.fullscreenLoop) {
      return Math.min(range, Math.floor(numOfitems / 2));
    } else {
      return Math.min(range, numOfitems);
    }
  };

  _proto.getOrCreateGalleryItem = function getOrCreateGalleryItem(itemIdx) {
    //calc itemParams and clear cache if one of them had changed
    var itemParams = {
      windowSize: this.currentWindowSize(),
      styles: this.props.styles,
      watermark: this.props.watermark
    };
    var stringifiedItemParams = JSON.stringify(itemParams);
    var shouldClearGalleryItems = stringifiedItemParams !== this.lastItemParams;

    if (shouldClearGalleryItems) {
      this.galleryItems = [];
      this.lastItemParams = stringifiedItemParams;
    }

    if (!this.galleryItems[itemIdx]) {
      var item = this.props.items[itemIdx];
      this.galleryItems[itemIdx] = item ? prepareFullscreenItem(_objectSpread({
        item: item,
        itemIdx: itemIdx,
        scale: this.getCurrentWindowScale(),
        isFullscreen: this.state.isFullscreen,
        watermark: this.props.watermark
      }, itemParams)) : undefined;
    }

    return this.galleryItems[itemIdx];
  };

  _proto.getMoreItemsIfNeeded = function getMoreItemsIfNeeded(nextIdx) {
    if (this.props.totalItemsCount > this.props.items.length && nextIdx > this.props.items.length - this.extraImages) {
      var itemsLength = this.props.items.length;
      this.eventsListener(FULLSCREEN_EVENTS.NEED_MORE_ITEMS, itemsLength);
    }
  };

  _proto.getItemsToDisplay = function getItemsToDisplay() {
    if (this.shouldUseProGallerySlider) {
      return this.props.items.map(function (item, index) {
        item.fullscreenIdx = index;
        return item;
      });
    }

    var items = this.props.items;
    var idx = this.state.current.idx;
    var range = this.getItemsDisplayRange();
    var startIdx = idx - range;
    var endIdx = idx + range; //create a fixed size items array (size = range * 2 + 1)

    var itemsToDisplay = [];
    var numOfitems = items.length;
    var itemIdx;

    for (var i = startIdx; i <= endIdx; i++) {
      if (this.props.styles.fullscreenLoop) {
        itemIdx = i % numOfitems;
      } else {
        itemIdx = i;
      }

      itemsToDisplay.push(this.getItem(itemIdx));
    }

    return itemsToDisplay;
  };

  _proto.closeBrowserFullscreen = function closeBrowserFullscreen(shouldCloseFullscreen) {
    var _this4 = this;

    if (shouldCloseFullscreen === void 0) {
      shouldCloseFullscreen = false;
    }

    //TODO search expand word, replace with fullscreen
    if (this.state.isFullscreen) {
      this.setState({
        isFullscreen: false,
        showInfo: this.props.styles.defaultShowInfoExpand && this.state.current.hasInfo,
        infoToggledByUser: false
      }, function () {
        _this4.eventsListener(FULLSCREEN_EVENTS.TOGGLE_BROWSER_FULLSCREEN);

        if (shouldCloseFullscreen) {
          var eventData = {
            itemIdx: _this4.state.current.idx,
            animationDuration: 0
          };

          _this4.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
        }
      });
    } else {
      var eventData = {
        itemIdx: this.state.current.idx
      };
      this.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
    }
  };

  _proto.openBrowserFullscreen = function openBrowserFullscreen() {
    var _this5 = this;

    // TODO: merge this function, does the same as closeBrowserFullscreen
    this.setState({
      isFullscreen: true,
      showInfo: false,
      infoToggledByUser: false
    }, function () {
      return _this5.eventsListener(FULLSCREEN_EVENTS.TOGGLE_BROWSER_FULLSCREEN);
    });
  };

  _proto.nextSlide = function nextSlide(direction, nextIdx, callback) {
    var _this6 = this;

    //this method should be called AFTER the animation is finished!
    if (!_.isFunction(callback)) callback = _.noop; //disable circling photos

    nextIdx = _.isUndefined(nextIdx) || _.isNull(nextIdx) ? this.getNextitem(Number(this.state.current.idx), direction) : nextIdx;

    if (nextIdx === this.state.current.idx) {
      callback();
      return;
    }

    if (_.isUndefined(nextIdx)) {
      callback();
      this.closeFullscreen();
    } else {
      var currentItem = this.getItemStateByIdx(nextIdx);
      this.setState({
        current: currentItem,
        showInfo: !this.state.isFullscreen && currentItem.hasInfo && (this.props.styles.defaultShowInfoExpand || this.state.infoToggledByUser),
        animating: false,
        direction: 0
      }, function () {
        _this6.getMoreItemsIfNeeded(nextIdx);

        _this6.eventsListener(FULLSCREEN_EVENTS.ON_NEXT_SLIDE, nextIdx); //iFrame only (pro-fullscreen-tpa-wrapper)


        var eventData = {
          item: currentItem.item
        };

        _this6.eventsListener(FULLSCREEN_EVENTS.UPDATE_CURRENT_ITEM, eventData);

        callback();
      });
    }
  };

  _proto.toggleInfo = function toggleInfo(forceVal) {
    if (this.state.isFullscreen) {
      this.setState({
        showInfo: false
      });
    } else {
      var showInfo = _.isUndefined(forceVal) ? !this.state.showInfo : forceVal;
      utils.setStateAndLog(this, 'toggleInfo', {
        showInfo: showInfo
      });
      this.setState({
        infoToggledByUser: showInfo
      });
    }
  };

  _proto.toggleShareScreen = function toggleShareScreen() {
    this.setState({
      showShareScreen: !this.state.showShareScreen
    });
  } //--------------------------------------------| UI Actions |-------------------------------------------//
  ;

  _proto.fadeToNextSlide = function fadeToNextSlide(direction) {
    var _this7 = this;

    if (direction !== 0 && !this.state.animating) {
      utils.setStateAndLog(this, 'fadeToNextSlide animation start', {
        animating: true,
        direction: direction
      }, function () {
        setTimeout(function () {
          _this7.actions.next(direction); //triggers react after the animation is complete


          _this7.fixTransformForApple();
        }, 400);
      });
    }
  };

  _proto.handleOnTap = function handleOnTap(event) {
    var className = _.get(event, 'target.className') || '';

    if (typeof className === 'string' || className instanceof String) {
      return !this.itemClickIsOpenInFullscreen && (className.indexOf('fullscreen-item') >= 0 || className.indexOf('fullscreen-preload') >= 0) ? this.toggleFullscreen(true) : {};
    }
  };

  _proto.toggleZoom = function toggleZoom(bool) {
    this.setState({
      isMobileZoom: bool
    });
  };

  _proto.onTouchStart = function onTouchStart(event) {
    var className = _.get(event, 'target.className') || '';
    this.isSwipping = false;

    if (typeof className === 'string' || className instanceof String) {
      if (event.touches.length === 2) {
        return className.indexOf('gallery-item') >= 0 || className.indexOf('te-pro-gallery-text-item') >= 0 ? this.toggleZoom(true) : {};
      }
    }
  };

  _proto.onTouchMove = function onTouchMove() {
    this.isSwipping = true;
  };

  _proto.onTouchEnd = function onTouchEnd(event) {
    if (this.isSwipping) {
      this.setIsSwipping(false);
      return;
    }

    var className = _.get(event, 'target.className') || '';

    if (typeof className === 'string' || className instanceof String) {
      return className.indexOf('gallery-item') >= 0 || className.indexOf('te-pro-gallery-text-item') >= 0 ? this.toggleFullscreen(true) : {};
    }
  };

  _proto.toggleFullscreen = function toggleFullscreen(valueOrEvent) {
    if (_.isBoolean(valueOrEvent)) {
      if (this.isLandscape) {
        var eventData = {
          itemIdx: this.state.current.idx
        };
        this.eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, eventData);
      } else {
        this.setState({
          isFullscreen: valueOrEvent
        });
      }
    } else {
      var tapTargetClass = _.get(valueOrEvent, 'target.className') || '';

      if (typeof tapTargetClass === 'string' || tapTargetClass instanceof String) {
        if (tapTargetClass.indexOf('fullscreen-item') >= 0 || tapTargetClass.indexOf('fullscreen-preload') >= 0) {
          //make sure that the tap is on the image / preload
          this.setState({
            // TURBO: use prevState func
            isFullscreen: !this.state.isFullscreen
          });
        }
      } else {// console.log('Not Toggling Zoom Mode', (_.get(tapEvent, 'target.className') || '').indexOf('fullscreen-item'), (_.get(tapEvent, 'target.className')), tapEvent);
      }
    }
  } //-----------------------------------------| DOM Manipulation |----------------------------------------//
  ;

  _proto.fixLinkLineHeight = function fixLinkLineHeight() {
    var curItem = this.state.current.item;

    if (curItem.linkUrl && curItem.linkText) {
      //patch to limit link lines to 2
      try {
        var elem = $(ReactDOM.findDOMNode(this));
        if (!elem) return;
        var link = elem.find('.fullscreen-side-bar-exif.pro-fullscreen-link');

        if (link.length !== 1) {
          return;
        }

        var lineHeight = parseInt(link.css('line-height'));
        var numOfLines = 2;
        link.height(numOfLines * lineHeight);
        link.css({
          '-webkit-line-clamp': numOfLines + ''
        });
      } catch (e) {
        return;
      }
    }
  };

  _proto.fixTransformForApple = function fixTransformForApple() {
    if (utils.isiOS()) {
      $('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform');
    } else if (utils.browserIs('safari')) {
      var transform = 'translate3d(0, 0, 0)';
      var duration = '0ms';
      $('.pro-fullscreen-swipe-wrap .pro-fullscreen-slide').css('will-change', 'transform').css('transform', transform).css('-webkit-transform', transform).css('-moz-transform', transform).css('-ms-transform', transform).css('-o-transform', transform).css('transition-duration', duration).css('-webkit-transition-duration', duration).css('-moz-transition-duration', duration).css('-ms-transition-duration', duration).css('-o-transition-duration', duration);
    }
  };

  _proto.hasContainerChanged = function hasContainerChanged(container, prevContainer) {
    return container.width !== prevContainer.width || container.height !== prevContainer.height;
  } //------------------------------------------| React methods |------------------------------------------//
  ;

  _proto.componentDidMount = function componentDidMount() {
    if (typeof this.props.formFactor !== 'undefined') {
      viewModeWrapper.setFormFactor(this.props.formFactor);
    }

    this.eventsListener(FULLSCREEN_EVENTS.FULLSCREEN_LOADED, this.state.current.item);

    if (utils.isTouch() && !this.shouldUseProGallerySlider) {
      this.swipper = new Swipper({
        container: this.props.container,
        onTap: this.handleOnTap,
        allowSwipe: true,
        allowPinch: this.state.isFullscreen && !_.get(this, 'props.current.item.isVideo'),
        allowScroll: !this.state.isFullscreen,
        mobileSwipeAnimation: this.props.styles.mobileSwipeAnimation,
        isRTL: this.props.styles.isRTL
      }, this.actions.next);
      this.swipper.update();
    }

    if (utils.isTouch() || this.shouldUseProGallerySlider) {
      this.element && this.element.focus();
    }

    this.isLandscape = this.isLandscapeInMobile();

    if (this.isLandscape) {
      this.setState({
        isFullscreen: true
      });
    }

    this.initEvents();
    this.handleMouseMove(); //show the icons (that will show on mouse move) on startup
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _this8 = this;

    //check is this is really needed (do not do on every state change)
    this.fixLinkLineHeight();
    this.fixTransformForApple();
    var isFullscreen = this.state.isFullscreen;
    var mobileSwipeAnimation = this.props.styles.mobileSwipeAnimation;

    if (this.swipper) {
      this.swipper.enable();
      this.swipper.update();

      if (isFullscreen !== prevState.isFullscreen || mobileSwipeAnimation !== prevProps.styles.mobileSwipeAnimation || this.hasContainerChanged(this.props.container, prevProps.container)) {
        this.swipper.init({
          container: this.props.container,
          onTap: this.handleOnTap,
          allowSwipe: true,
          allowPinch: !!isFullscreen,
          allowScroll: !isFullscreen,
          mobileSwipeAnimation: mobileSwipeAnimation
        });
      }
    }

    if (utils.isTouch()) {
      this.element && this.element.focus();
    }

    if (utils.isOOI()) {
      if (!prevProps.styles.isAccessible && this.props.styles.isAccessible) {
        this.setState({
          initialArrowsFocus: true
        }, function () {
          _this8.setState({
            initialArrowsFocus: false
          });
        });
      }
    }

    if (this.props.itemsLoveData !== prevProps.itemsLoveData) {
      var currItem = this.getItemStateByIdx(this.state.current.idx);
      this.setState({
        current: currItem
      });
    }

    if (this.props.viewMode !== prevProps.viewMode) {
      viewModeWrapper.setViewMode(this.props.viewMode);
    }

    if (this.props.formFactor !== prevProps.formFactor) {
      viewModeWrapper.setFormFactor(this.props.formFactor);
    }
  } //WARNING! To be deprecated in React v17. Use new lifecycle static getDerivedStateFromProps instead.
  ;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.styles, nextProps.styles) || !_.isEqual(this.props.container, nextProps.container)) {
      replaceWindowElement({
        type: 'style',
        id: 'inlineDynamicFullscreenWixParamsCss',
        attributes: {
          type: 'text/css'
        },
        innerHTML: createFullscreenStyle(nextProps.styles),
        parentElement: window.document.getElementsByTagName('head')[0]
      });

      if (nextProps.styles.googleFontsCssUrl) {
        replaceWindowElement({
          type: 'style',
          id: 'inlineDynamicFullscreenWixParamsFont',
          attributes: {
            type: 'text/css',
            rel: 'stylesheet',
            href: nextProps.styles.googleFontsCssUrl
          },
          parentElement: window.document.getElementsByTagName('head')[0]
        });
      }

      this.setState({
        showInfo: !this.state.isFullscreen && this.state.current.hasInfo && (nextProps.styles.defaultShowInfoExpand || this.state.infoToggledByUser),
        currentWindow: this.getCurrentWindowState()
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearEvents();
  } //____________________________________getters_____________________________________
  ;

  _proto.hasAdditionalSidebarElement = function hasAdditionalSidebarElement() {
    if (utils.isMobile()) {
      var customMobileSidebarRenderer = this.props.customMobileSidebarRenderer;
      return typeof customMobileSidebarRenderer === 'function';
    } else {
      var additionalSidebarElement = this.props.additionalSidebarElement;
      return typeof additionalSidebarElement === 'function';
    }
  };

  _proto.getSmallScreenArrows = function getSmallScreenArrows(isNewLayout, isSmallScreen, isTouch, totalItems) {
    return false;
  };

  _proto.getFullscreenClasses = function getFullscreenClasses() {
    var versionClassName = 'v2';
    var expandedClassName = this.state.isFullscreen ? ' pro-fullscreen-expanded ' : '';
    var themeClassName = utils.parseGetParam('theme') === 'dark' ? ' fullscreen-dark' : ' fullscreen-bright';
    var accessibilityClassName = '';

    if (utils.isOOI()) {
      accessibilityClassName = this.props.styles.isAccessible ? ' pro-fullscreen-accessible ' : '';
    } else {
      accessibilityClassName = utils.isAccessibilityEnabled() ? ' pro-fullscreen-accessible ' : '';
    }

    var mobileClassName = utils.isMobile() ? 'pro-fullscreen-mobile' : '';
    return "fullscreen pro-fullscreen pro-fullscreen-inline-styles inline-styles pro-fullscreen-" + versionClassName + " " + expandedClassName + " " + themeClassName + " " + accessibilityClassName + " " + mobileClassName;
  };

  _proto.getMobileExpand = function getMobileExpand() {
    var _this$state2 = this.state,
        current = _this$state2.current,
        animating = _this$state2.animating,
        direction = _this$state2.direction,
        showShareScreen = _this$state2.showShareScreen,
        refocusArrows = _this$state2.refocusArrows,
        initialArrowsFocus = _this$state2.initialArrowsFocus,
        showInfo = _this$state2.showInfo;
    var _this$props = this.props,
        items = _this$props.items,
        styles = _this$props.styles,
        additionalSidebarElement = _this$props.additionalSidebarElement,
        customMobileSidebarRenderer = _this$props.customMobileSidebarRenderer,
        animationDuration = _this$props.animationDuration,
        homeGalleryPageUrl = _this$props.homeGalleryPageUrl,
        additionalNavbarElement = _this$props.additionalNavbarElement,
        customDownloadUrl = _this$props.customDownloadUrl,
        isPreview = _this$props.isPreview,
        locale = _this$props.locale,
        deviceType = _this$props.deviceType,
        viewMode = _this$props.viewMode,
        customSidebarRenderer = _this$props.customSidebarRenderer,
        isAdditionalMobileSidebarOpened = _this$props.isAdditionalMobileSidebarOpened,
        noFollowForSEO = _this$props.noFollowForSEO,
        container = _this$props.container,
        shouldUseNewSocialSharePopup = _this$props.shouldUseNewSocialSharePopup;
    var props = {
      items: this.getItemsToDisplay(),
      isLandscape: this.isLandscape,
      current: this.getItemStateByIdx(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      container: container,
      styles: styles,
      animating: animating,
      direction: direction,
      totalItems: items.length,
      additionalSidebarElement: additionalSidebarElement,
      showShareScreen: showShareScreen,
      customMobileSidebarRenderer: customMobileSidebarRenderer,
      refocusArrows: refocusArrows,
      initialArrowsFocus: initialArrowsFocus,
      actions: this.actions,
      animationDuration: animationDuration,
      id: current.item.id,
      idx: current.item.idx,
      itemId: current.item.id,
      homeGalleryPageUrl: homeGalleryPageUrl,
      additionalNavbarElement: additionalNavbarElement,
      showInfo: showInfo,
      isFirst: true,
      customDownloadUrl: customDownloadUrl,
      isPreview: isPreview,
      hasAdditionalSidebarElement: this.hasAdditionalSidebarElement(),
      locale: locale,
      deviceType: deviceType,
      viewMode: viewMode,
      customSidebarRenderer: customSidebarRenderer,
      shouldShowInfo: this.shouldShowInfo(),
      isAdditionalMobileSidebarOpened: isAdditionalMobileSidebarOpened,
      noFollowForSEO: noFollowForSEO,
      fullscreenClasses: this.getFullscreenClasses(),
      setRef: this.setRef,
      shouldUseProGallerySlider: this.shouldUseProGallerySlider,
      resizeMediaUrl: resizeMediaUrl,
      shouldUseNewSocialSharePopup: shouldUseNewSocialSharePopup,
      isMobileZoom: this.state.isMobileZoom,
      currentGalleryItem: this.state.currentGalleryItem
    };
    return /*#__PURE__*/React.createElement(MobileExpand, props);
  };

  _proto.getMobileFullscreen = function getMobileFullscreen() {
    var _this$state3 = this.state,
        animating = _this$state3.animating,
        direction = _this$state3.direction,
        showShareScreen = _this$state3.showShareScreen,
        refocusArrows = _this$state3.refocusArrows,
        initialArrowsFocus = _this$state3.initialArrowsFocus;
    var _this$props2 = this.props,
        items = _this$props2.items,
        styles = _this$props2.styles,
        additionalSidebarElement = _this$props2.additionalSidebarElement,
        customMobileSidebarRenderer = _this$props2.customMobileSidebarRenderer,
        animationDuration = _this$props2.animationDuration,
        container = _this$props2.container;
    var props = {
      items: this.getItemsToDisplay(),
      isLandscape: this.isLandscape,
      current: this.getItemStateByIdx(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      styles: styles,
      animating: animating,
      direction: direction,
      totalItems: items.length,
      additionalSidebarElement: additionalSidebarElement,
      showShareScreen: showShareScreen,
      customMobileSidebarRenderer: customMobileSidebarRenderer,
      refocusArrows: refocusArrows,
      initialArrowsFocus: initialArrowsFocus,
      actions: this.actions,
      animationDuration: animationDuration,
      itemClickIsOpenInFullscreen: this.itemClickIsOpenInFullscreen,
      fullscreenClasses: this.getFullscreenClasses(),
      setRef: this.setRef,
      resizeMediaUrl: resizeMediaUrl,
      shouldUseProGallerySlider: this.shouldUseProGallerySlider,
      container: container,
      isMobileZoom: this.state.isMobileZoom,
      currentGalleryItem: this.state.currentGalleryItem
    };
    return /*#__PURE__*/React.createElement(MobileFullscreen, props);
  };

  _proto.getDesktopExpand = function getDesktopExpand() {
    var _this$state4 = this.state,
        current = _this$state4.current,
        animating = _this$state4.animating,
        direction = _this$state4.direction,
        showShareScreen = _this$state4.showShareScreen,
        refocusArrows = _this$state4.refocusArrows,
        initialArrowsFocus = _this$state4.initialArrowsFocus,
        showInfo = _this$state4.showInfo,
        shouldRefocusOnCloseXButton = _this$state4.shouldRefocusOnCloseXButton;
    var _this$props3 = this.props,
        items = _this$props3.items,
        styles = _this$props3.styles,
        additionalSidebarElement = _this$props3.additionalSidebarElement,
        animationDuration = _this$props3.animationDuration,
        homeGalleryPageUrl = _this$props3.homeGalleryPageUrl,
        additionalNavbarElement = _this$props3.additionalNavbarElement,
        navigatedInto = _this$props3.navigatedInto,
        customDownloadUrl = _this$props3.customDownloadUrl,
        isPreview = _this$props3.isPreview,
        locale = _this$props3.locale,
        deviceType = _this$props3.deviceType,
        viewMode = _this$props3.viewMode,
        customSidebarRenderer = _this$props3.customSidebarRenderer,
        noFollowForSEO = _this$props3.noFollowForSEO,
        shouldUseNewSocialSharePopup = _this$props3.shouldUseNewSocialSharePopup;
    var props = {
      animating: animating,
      direction: direction,
      showShareScreen: showShareScreen,
      refocusArrows: refocusArrows,
      initialArrowsFocus: initialArrowsFocus,
      showInfo: showInfo,
      shouldRefocusOnCloseXButton: shouldRefocusOnCloseXButton,
      styles: styles,
      additionalSidebarElement: additionalSidebarElement,
      animationDuration: animationDuration,
      homeGalleryPageUrl: homeGalleryPageUrl,
      additionalNavbarElement: additionalNavbarElement,
      navigatedInto: navigatedInto,
      customDownloadUrl: customDownloadUrl,
      isPreview: isPreview,
      locale: locale,
      deviceType: deviceType,
      viewMode: viewMode,
      customSidebarRenderer: customSidebarRenderer,
      noFollowForSEO: noFollowForSEO,
      items: this.getItemsToDisplay(),
      current: this.getItemStateByIdx(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      actions: this.actions,
      hasAdditionalSidebarElement: this.hasAdditionalSidebarElement(),
      shouldShowInfo: this.shouldShowInfo(),
      isAdditionalMobileSidebarOpened: false,
      totalItems: items.length,
      id: current.item.id,
      idx: current.item.idx,
      itemId: current.item.id,
      isLandscape: this.isLandscape,
      fullscreenClasses: this.getFullscreenClasses(),
      setRef: this.setRef,
      resizeMediaUrl: resizeMediaUrl,
      shouldUseProGallerySlider: this.shouldUseProGallerySlider,
      shouldUseNewSocialSharePopup: shouldUseNewSocialSharePopup
    };
    return /*#__PURE__*/React.createElement(DesktopExpand, props);
  };

  _proto.getDesktopFullscreen = function getDesktopFullscreen() {
    var _this$state5 = this.state,
        animating = _this$state5.animating,
        direction = _this$state5.direction,
        showShareScreen = _this$state5.showShareScreen,
        refocusArrows = _this$state5.refocusArrows,
        initialArrowsFocus = _this$state5.initialArrowsFocus,
        shouldRefocusOnCloseXButton = _this$state5.shouldRefocusOnCloseXButton,
        current = _this$state5.current;
    var _this$props4 = this.props,
        items = _this$props4.items,
        styles = _this$props4.styles,
        homeGalleryPageUrl = _this$props4.homeGalleryPageUrl,
        additionalNavbarElement = _this$props4.additionalNavbarElement,
        customDownloadUrl = _this$props4.customDownloadUrl,
        isPreview = _this$props4.isPreview;
    var props = {
      items: this.getItemsToDisplay(),
      animating: animating,
      direction: direction,
      showShareScreen: showShareScreen,
      refocusArrows: refocusArrows,
      initialArrowsFocus: initialArrowsFocus,
      shouldRefocusOnCloseXButton: shouldRefocusOnCloseXButton,
      totalItems: items.length,
      styles: styles,
      homeGalleryPageUrl: homeGalleryPageUrl,
      additionalNavbarElement: additionalNavbarElement,
      customDownloadUrl: customDownloadUrl,
      isPreview: isPreview,
      id: current.item.id,
      idx: current.item.idx,
      itemId: current.item.id,
      isLandscape: this.isLandscape,
      itemClickIsOpenInFullscreen: this.itemClickIsOpenInFullscreen,
      current: this.getItemStateByIdx(this.state.current.idx),
      currentWindow: this.getCurrentWindowState(),
      actions: this.actions,
      fullscreenClasses: this.getFullscreenClasses(),
      setRef: this.setRef,
      resizeMediaUrl: resizeMediaUrl,
      shouldUseProGallerySlider: this.shouldUseProGallerySlider
    };
    return /*#__PURE__*/React.createElement(DesktopFullscreen, props);
  };

  _proto.setRef = function setRef(ref) {
    this.element = ref;
  } //________________________________________________________________________________
  ;

  _proto.renderFullscreen = function renderFullscreen() {
    var isFullscreen = this.state.isFullscreen;
    var isMobile = utils.isMobile();
    var fullscreenElement;

    if (isMobile) {
      if (isFullscreen) {
        fullscreenElement = this.getMobileFullscreen();
      } else {
        fullscreenElement = this.getMobileExpand();
      }
    } else {
      if (isFullscreen) {
        fullscreenElement = this.getDesktopFullscreen();
      } else {
        fullscreenElement = this.getDesktopExpand();
      }
    }

    return fullscreenElement;
  };

  _proto.render = function render() {
    if (utils.isVerbose()) {
      console.timeEnd('Time in React');
      console.log('Render FullscreenView', this.props, this.state);
    }

    return this.renderFullscreen();
  };

  return ProFullscreen;
}(React.Component);

ProFullscreen.defaultProps = {
  items: [],
  initialIdx: 0,
  locale: 'en',
  deviceType: 'desktop',
  isPreview: false,
  viewMode: 'SITE'
};
export default ProFullscreen;